import React from "react";

export const Logo = ({ light = false, className = "" }) => {
  return (
    <div
      className={"flex items-center gap-2 " + className}
      data-testid="fawks-logo"
    >
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-xl bg-gradient-purple shadow-[0_8px_30px_-8px_rgba(125,104,194,0.7)]" />
        <svg
          viewBox="0 0 32 32"
          className="absolute inset-0 h-full w-full p-1.5 text-white"
          fill="none"
        >
          <path
            d="M6 22 L14 6 L18 14 L26 10 L20 22 Z"
            fill="currentColor"
            opacity="0.95"
          />
          <circle cx="22" cy="11" r="1.5" fill="#0b0a18" />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={
            "font-display text-[1.05rem] font-extrabold tracking-tight " +
            (light ? "text-white" : "text-[#0b0a18]")
          }
        >
          Fawks<span className="text-[#7D68C2]">.</span>AI
        </span>
        <span
          className={
            "text-[0.55rem] font-medium uppercase tracking-[0.2em] " +
            (light ? "text-white/70" : "text-neutral-500")
          }
        >
          voice · whatsapp · chat
        </span>
      </div>
    </div>
  );
};

export default Logo;
